export default "__VITE_ASSET__PpH6igYQ__"